// Cores dos horarios no calendario (mesmas no claro e no escuro: o fundo
// e translucido, entao combina com os dois temas).
export const CORES = {
  available: {
    fundo: "rgba(20,184,166,.16)",
    borda: "#14b8a6",
    texto: "#0f766e",
  },
  booked: {
    fundo: "linear-gradient(135deg,#3b82f6,#2563eb)",
    borda: "#1d4ed8",
    texto: "#ffffff",
  },
  blocked: {
    fundo:
      "repeating-linear-gradient(45deg, rgba(148,163,184,.25) 0, rgba(148,163,184,.25) 6px, rgba(148,163,184,.12) 6px, rgba(148,163,184,.12) 12px)",
    borda: "#94a3b8",
    texto: "#64748b",
  },
};

const ROTULOS = {
  available: "Livre",
  booked: "Entrevista marcada",
  blocked: "Bloqueado",
};

export const rotuloStatus = (status) => ROTULOS[status] || status;
